import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "33",
  height: "32",
  viewBox: "0 0 33 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.4",
  d: "M21.5077 2.66699H26.0224C27.8921 2.66699 29.4071 4.19479 29.4071 6.08028V10.633C29.4071 12.5185 27.8921 14.0463 26.0224 14.0463H21.5077C19.6381 14.0463 18.123 12.5185 18.123 10.633V6.08028C18.123 4.19479 19.6381 2.66699 21.5077 2.66699Z",
  fill: "#1355FF"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.12493 2.66699H10.6396C12.5092 2.66699 14.0243 4.19479 14.0243 6.08028V10.633C14.0243 12.5185 12.5092 14.0463 10.6396 14.0463H6.12493C4.25524 14.0463 2.74023 12.5185 2.74023 10.633V6.08028C2.74023 4.19479 4.25524 2.66699 6.12493 2.66699ZM6.12493 17.9541H10.6396C12.5092 17.9541 14.0243 19.4819 14.0243 21.3674V25.9202C14.0243 27.8044 12.5092 29.3334 10.6396 29.3334H6.12493C4.25524 29.3334 2.74023 27.8044 2.74023 25.9202V21.3674C2.74023 19.4819 4.25524 17.9541 6.12493 17.9541ZM26.0224 17.9541H21.5078C19.6381 17.9541 18.1231 19.4819 18.1231 21.3674V25.9202C18.1231 27.8044 19.6381 29.3334 21.5078 29.3334H26.0224C27.8921 29.3334 29.4071 27.8044 29.4071 25.9202V21.3674C29.4071 19.4819 27.8921 17.9541 26.0224 17.9541Z",
  fill: "#1355FF"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }